// extracted by mini-css-extract-plugin
module.exports = {"single":"single_single_PGENj","title":"single_title_3OvNJ","authorization":"single_authorization_2u9DI","author":"single_author_1q2a5","active":"single_active_3wrvF"};